// COMPLIANCE: STATUS_COLORS violation detected - requires manual review
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useRoleTestSafe } from '@/contexts/RoleTestContext';
import { useUserRole } from '@/hooks/useUserRole';
import { RESPONSIVE } from '@/design-system';
import { cn } from '@/lib/utils';

const ROLE_DISPLAY_NAMES: Record<string, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  editor: 'Editor',
  author: 'Author',
};

export function RoleTestBanner() {
  const { testingAsRole, restoreOriginalRole, isTestingRole } = useRoleTestSafe();
  const { isActuallySuperAdmin } = useUserRole();

  // Only show banner if user is actually a super_admin and is testing a role
  if (!isActuallySuperAdmin || !isTestingRole || !testingAsRole) {
    return null;
  }

  return (
    <div className={`bg-amber-500/90 text-amber-950 px-3 sm:px-4 py-2 ${RESPONSIVE.headerWithActions} sticky top-0 z-50`}>
      <div className={cn(RESPONSIVE.flexRowCenterGap2)}>
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className={cn("font-medium", RESPONSIVE.textResponsive)}>
          Role Testing Mode: Viewing as <strong>{ROLE_DISPLAY_NAMES[testingAsRole] || testingAsRole}</strong>
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={restoreOriginalRole}
        className="bg-amber-100 border-amber-600 text-amber-900 hover:bg-amber-200 hover:text-amber-950 w-full sm:w-auto"
      >
        <RotateCcw className="h-3 w-3 mr-1" />
        Restore Super Admin
      </Button>
    </div>
  );
}
